import React from 'react';
import { Scale, FileSearch, Send, Printer, CheckCircle2 } from 'lucide-react';
export function Mechanism() {
  const steps = [{
    letter: 'R',
    title: 'Revisar',
    icon: FileSearch
  }, {
    letter: 'A',
    title: 'Analizar',
    icon: FileSearch
  }, {
    letter: 'P',
    title: 'Procesar',
    icon: CheckCircle2
  }, {
    letter: 'I',
    title: 'Imprimir',
    icon: Printer
  }, {
    letter: 'D',
    title: 'Disputar',
    icon: Send
  }];
  return <section className="bg-navy-800 px-4 py-16 sm:px-6 lg:px-8 lg:py-24 relative overflow-hidden" data-id="element-135">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 h-64 w-64 rounded-full bg-gold-500/5 blur-[100px]" data-id="element-136"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 h-64 w-64 rounded-full bg-blue-500/5 blur-[100px]" data-id="element-137"></div>

      <div className="mx-auto max-w-4xl relative z-10" data-id="element-138">
        <div className="mb-12 text-center" data-id="element-139">
          <div className="inline-flex items-center justify-center p-3 bg-gold-500/10 rounded-full mb-6" data-id="element-140">
            <Scale className="h-8 w-8 text-gold-400" data-id="element-141" />
          </div>
          <h2 className="mb-6 text-4xl sm:text-5xl font-bebas text-white" data-id="element-142">
            El Mecanismo:{' '}
            <span className="text-gold-400" data-id="element-143">La Ley FCRA a tu Favor</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto" data-id="element-144">
            La Ley Federal FCRA obliga a los burós a eliminar cualquier
            información que no sea 100% verificable.
          </p>
        </div>

        <div className="mb-12 flex flex-nowrap justify-center gap-3 sm:gap-6" data-id="element-145">
          {steps.map((step, index) => <div key={index} className="flex flex-col items-center" data-id="element-146">
              <div className="flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-navy-900 border-2 border-gold-400/30 text-lg sm:text-xl font-bebas text-gold-400 shadow-[0_0_15px_rgba(212,168,67,0.15)] mb-2" data-id="element-147">
                {step.letter}
              </div>
              <span className="text-xs sm:text-sm font-bold text-slate-200" data-id="element-148">
                {step.title}
              </span>
            </div>)}
        </div>

        <div className="rounded-2xl bg-gradient-to-br from-navy-900 to-navy-950 p-8 border border-gold-500/20 shadow-2xl relative overflow-hidden" data-id="element-149">
          <div className="absolute top-0 left-0 w-1 h-full bg-gold-400" data-id="element-150"></div>
          <p className="text-lg text-slate-300 leading-relaxed relative z-10" data-id="element-151">
            Si el banco no puede probar cada detalle del contrato original,{' '}
            <strong className="text-white" data-id="element-152">
              la ley los obliga a borrarlo de tu reporte en 30 días
            </strong>
            . Esta guía te muestra exactamente cómo activar esa protección —
            paso a paso — desde tu casa.
          </p>
        </div>
      </div>
    </section>;
}